export default __webpack_public_path__ + "./images/py.a8c0c50e.png";